import { render, staticRenderFns } from "./FlitPartnershipPage.vue?vue&type=template&id=40c19b0d&scoped=true"
import script from "./FlitPartnershipPage.vue?vue&type=script&lang=js"
export * from "./FlitPartnershipPage.vue?vue&type=script&lang=js"
import style0 from "./FlitPartnershipPage.vue?vue&type=style&index=0&id=40c19b0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c19b0d",
  null
  
)

export default component.exports